export const MenuList = [
  {
    path: 'index.html',
    label: '首页',
    activePath: ['', 'index.html'],
  },
  {
    path: 'masterStyle.html',
    label: '大师风采',
    activePath: ['masterStyle.html', 'masterDetail.html'],
  },
  {
    path: 'masterClassroom.html',
    label: '大师讲堂',
    activePath: ['liveDetails.html', 'livePlay.html', 'livePlayback.html'],
  },
  {
    path: 'workTypeClassroom.html',
    label: '工种课堂',
    activePath: ['courseDetails.html', 'coursePlay.html'],
  },
  {
    path: 'specialTraining.html',
    label: '专题培训',
    activePath: ['specialList.html', 'specialDetails.html'],
  },
  {
    path: 'masterDuty.html',
    label: '大师值班室',
    activePath: ['masterDuty.html'],
  },
  {
    path: 'v/#/exam/choice?source=mySpecialRule',
    label: '考试中心',
    isPublicDomain: true,
    activePath: [],
  },
  {
    path: 'liveSchedule.html',
    label: '直播课表',
    activePath: ['liveSchedule.html'],
  },
];
